import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Home, ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Página no encontrada | pasta-base.cl"
        description="La página que buscas no existe o fue movida."
        path="/404"
      />
      <div className="mx-auto max-w-3xl px-5 py-24 text-center lg:px-8">
        <span className="text-xs font-bold uppercase tracking-[0.25em] text-emerald-400">
          Error 404
        </span>
        <h1 className="mt-4 text-5xl font-extrabold tracking-tight text-slate-50 sm:text-6xl">
          Página no encontrada
        </h1>
        <p className="mx-auto mt-5 max-w-xl text-lg text-slate-300">
          La página que buscas no existe o fue movida. Vuelve al inicio o
          explora las secciones del sitio.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="btn-press inline-flex items-center gap-2 rounded-full bg-emerald-500 px-6 py-3 text-sm font-semibold text-slate-950 hover:bg-emerald-400"
          >
            <Home className="h-4 w-4" />
            Ir al inicio
          </Link>
          <Link
            to="/preguntas-frecuentes"
            className="inline-flex items-center gap-2 rounded-full border border-slate-700 bg-slate-900 px-6 py-3 text-sm font-semibold text-slate-200 hover:bg-slate-800"
          >
            Preguntas Frecuentes
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </>
  );
}
